import { React } from '../../../lib';
import { ReportFrameComponent } from './frame';
export { loadParametersGeneric } from './frame';
export { definedComponentsGeneric } from './options';
export const ReportFrame = React.forwardRef(ReportFrameComponent);
//# sourceMappingURL=index.js.map